import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImageComponent } from '@shared/components/image';
import { PopinImage } from '@shared/components/popin-image/models';
import { SvgComponent } from '@shared/components/svg';

@Component({
  imports: [ImageComponent, SvgComponent],
  templateUrl: './popin-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinImageComponent {
  data = inject(DIALOG_DATA) as PopinImage;
  protected readonly dialogRef = inject(DialogRef);
}
